
import React from "react"
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import { setErrorMessage, setMessage, clearMessage, setHTMLMessage } from "../../tools/errorhandling";
import hotelcss from '../css/hotelhotellist.module.css';

import {
    getEmployer, createEmployer, UpdateEmployer
} from "../../dbconnector/connector";
import { saveFile } from "../../tools/filehandler";
import { useParams } from "react-router-dom";
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import EmployerNode from '../../customNodes/EmployerNode';
//AddDocumentType

import { use } from "react";
import moment, { now } from "moment";

const EmployerPage = (props) => {
    const t = props.translation
    const [employer, setEmployer] = useState({});
    const [Edit, setEdit] = useState(true);
    const [dragwindow, setDragWindow] = useState(false);
    const [windowtodrag, setWindowtodrag] = useState(null);
    const [left, setleft] = useState(0);
    const [top, settop] = useState(0);

    let { id } = useParams();
    const navigate = useNavigate()


    useEffect(() => {
        LoadEmployer();

    }, []);

    const LoadEmployer = () => {
        setEmployer([])
        setEdit(true);
        if (id !== undefined) {
            getEmployer(id).then(res => {
                console.log(res)
                try {
                    setEmployer(res.employer[0])

                } catch (e) {
                    setErrorMessage(t("error_retreivingData"))
                }
            })
            document.getElementById("editDiv").style.display = "grid";
            document.getElementById("saveDiv").style.display = "none";
        }

    }

    const onSubmit = (e) => {
        const response = UpdateEmployer({ ...employer }, employer.id)
        response.then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    console.log("body", body)
                })
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }



    function formatDateToYYYYMMDD(date) {
        if (date !== null) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
            const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
            return `${year}-${month}-${day}`;
        }
        else {
            return null
        }
    }


    const changevalue = (e) => {
        console.log("[", e.target.name, "]:", e.target.checked)
        setEmployer((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }

        })

    }



    const navigateback = () => {
        navigate('/employers/employerlist')
    }

    const handleEdit = () => {
        if (props.rights === 2) {
            setEdit(false)
        } else if (props.rights === 4) {
        }
        document.getElementById("editDiv").style.display = "none";
        document.getElementById("saveDiv").style.display = "grid";
    }

    const handleCancel = () => {
        //document.getElementById("coverAll").style.display= 'none'
        LoadEmployer()
        navigateback();
    }

    const startdrag = (windowname, drag, e) => {
        setWindowtodrag(windowname)
        if (e !== null) {
            var rect = e.target.getBoundingClientRect();
            setleft(e.clientX - rect.left)
            settop(e.clientY - rect.top)
            setDragWindow(drag)
            if (drag === true && windowname !== null) {
                resetzindexes(windowname)
            }
        }

    }


    const resetzindexes = (windowname) => {
        document.getElementById(windowname).style.zIndex = 2
    }

    return (
        <>
            <div id="main" className="main">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                                Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                            <br></br>
                            <center> <Button type="button" id="CloseMessageButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button> &nbsp;
                            </center>
                        </div>
                    </div>
                    <div className="checkinTime"><div id="timelabel" ></div><div id="time"></div></div></header>
                <div id="return" className="form">
                    <Button type="button" id="cancelButton" class="Savebutton btn btn-primary margin-right" onClick={navigateback} >{t('Naaroverzicht')}</Button>
                </div>
                <EmployerNode
                    rights={props.rights}
                    translation={props.translation}
                    isDisabled={Edit}
                    data={{ employer: employer }}
                    events={{ changevalue: changevalue, handleEdit: handleEdit, handleCancel: handleCancel, navigateback: navigateback, onSubmit: onSubmit, startdrag: startdrag }}
                />
            </div>
        </>
    )
}
export default EmployerPage